import { BrowserRouter } from 'react-router-dom';
import AppRouter from './router/AppRouter';
import GoogleAnalytics from './components/global/google-analytics';
import GoogleTagManager from './components/global/google-tag-manager';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <GoogleAnalytics />
      <GoogleTagManager />
      <AppRouter />
    </BrowserRouter>
  );
}

export default App;
